import React from "react";
import { Icon } from "semantic-ui-react";

const ComparisonItem = ({ label, value, minHeight, isCrm, isMatch }) => {
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <p
        style={{
          paddingLeft: 10,
          fontWeight: 600,
          margin: 0,
          minHeight: minHeight,
          minWidth: "50%",
        }}
      >
        {label}
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          paddingRight: 10,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          {Array.isArray(value) ? (
            value.map((item, index) => (
              <p
                key={index}
                style={{
                  color: isMatch[index] === false ? "red" : "#BEBEC1",
                  fontWeight: 600,
                  margin: 0,
                }}
              >
                {item}
              </p>
            ))
          ) : (
            <p
              style={{
                color: isMatch === false ? "red" : "#BEBEC1",
                fontWeight: 600,
                margin: 0,
              }}
            >
              {value}
            </p>
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", paddingLeft: 10 }}>
          {isMatch != null &&
            isCrm &&
            (Array.isArray(isMatch) ? (
              isMatch.some((match) => !match) ? (
                // Display an exclamation icon if any item in the array is false
                <Icon name="exclamation" color="red" style={{ fontSize: 25 }} />
              ) : (
                // Display a check icon if all items in the array are true
                <Icon name="check" color="green" size="large" />
              )
            ) : isMatch ? (
              <Icon name="check" color="green" size="large" />
            ) : (
              <Icon name="exclamation" color="red" style={{ fontSize: 25 }} />
            ))}
        </div>
      </div>
    </div>
  );
};
export default ComparisonItem;
